"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @preferred
 */
var service_1 = require("../service");
var _ = require("lodash");
var settings_1 = require("../settings");
var Wishlist;
(function (Wishlist) {
    function create(name, data) {
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("CreateWishList");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                Name: name,
                Data: data,
                __response: null
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Wishlist.create = create;
    function get(orderId, accessToken, showUnconfirmedFundings, productProperties) {
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("GetWishList");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                OrderID: orderId,
                AccessToken: accessToken,
                IncludedProperties: productProperties ? productProperties : settings_1.SettingsManager.getProductProperties(),
                ShowUnconfirmedFundings: showUnconfirmedFundings,
                __response: null
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Wishlist.get = get;
    function getForUser(userId, showUnconfirmedFundings, productProperties, showClosedOrders) {
        if (showClosedOrders === void 0) { showClosedOrders = false; }
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("GetWishListsForUser");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                ID: userId,
                IncludedProperties: productProperties ? productProperties : settings_1.SettingsManager.getProductProperties(),
                ShowUnconfirmedFundings: showUnconfirmedFundings,
                ShowClosedOrders: showClosedOrders,
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Wishlist.getForUser = getForUser;
    function cancel(orderId) {
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("CancelWishList");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                OrderID: orderId,
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Wishlist.cancel = cancel;
    function update(orderId, sortedLineIds, name, data) {
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("UpdateWishList");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                OrderID: orderId,
                Name: name,
                SortedWishListLineIDs: sortedLineIds,
                Data: data,
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Wishlist.update = update;
    function addProduct(orderId, productId, quanity, single) {
        if (quanity === void 0) { quanity = 1; }
        if (single === void 0) { single = true; }
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("AddProductToWishList");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                OrderID: orderId,
                ProductID: productId,
                Quantity: quanity,
                SingleProductPerLine: single
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Wishlist.addProduct = addProduct;
    function removeProduct(orderId, lineId, quanity) {
        if (quanity === void 0) { quanity = 1; }
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("RemoveProductFromWishList");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                OrderID: orderId,
                WishListLineID: lineId,
                Quantity: quanity,
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Wishlist.removeProduct = removeProduct;
    function addWishlistProductToOrder(orderId, accessToken, lines, lineActionType, name, remark) {
        if (lineActionType === void 0) { lineActionType = 4; }
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("AddWishListProductToOrder");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                WishListOrderID: orderId,
                AccessToken: accessToken,
                WishListLines: lines,
                LineActionType: lineActionType,
                Name: name,
                Remark: remark,
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Wishlist.addWishlistProductToOrder = addWishlistProductToOrder;
    function createPayment(orderId, accessToken, paymentMethodCode, properties, amount, name, remark, lines) {
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("CreateWishListPayment");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                OrderID: orderId,
                AccessToken: accessToken,
                Code: paymentMethodCode,
                Amount: amount,
                Properties: properties,
                Name: name,
                Remark: remark,
                Lines: lines,
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Wishlist.createPayment = createPayment;
    function setWishListOrderLineData(orderId, orderLineId, isHidden) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("SetWishListOrderLineData");
            var requestData = {
                OrderID: orderId,
                OrderLineID: orderLineId,
                IsHidden: isHidden
            };
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    Wishlist.setWishListOrderLineData = setWishListOrderLineData;
    function updateWishlistFunding(orderId, name, remark) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("UpdateWishListFunding");
            var requestData = {
                OrderID: orderId,
                Name: name,
                Remark: remark
            };
            service.call(requestData)
                .then(function (result) {
                resolve(true);
            })
                .catch(reject);
        });
    }
    Wishlist.updateWishlistFunding = updateWishlistFunding;
    function createWishListPaymentFromShoppingCart(wishlistId, cartId, code, name, remark, properties, token) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("CreateWishListPaymentFromShoppingCart");
            var requestData = {
                OrderID: wishlistId,
                DummyOrderID: cartId,
                Code: code,
                Remark: remark,
                Name: name,
                AccessToken: token,
                Properties: properties
            };
            service.call(requestData)
                .then(function (result) {
                resolve(result);
            })
                .catch(reject);
        });
    }
    Wishlist.createWishListPaymentFromShoppingCart = createWishListPaymentFromShoppingCart;
})(Wishlist = exports.Wishlist || (exports.Wishlist = {}));
